var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighLowPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48315 0.932934C5.17447 0.811158 4.81933 0.878786 4.58372 1.10225L0.741784 4.73795C0.419405 5.04277 0.419405 5.5375 0.741784 5.84231C1.06416 6.14738 1.58642 6.14738 1.90879 5.84231L4.34194 3.53978L4.34194 16.2328C4.34194 16.6642 4.71133 17.0138 5.16722 17.0138C5.62312 17.0138 5.99251 16.6642 5.99251 16.2328L5.99251 1.65443C5.99252 1.33843 5.79156 1.05369 5.48315 0.932934Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2429 12.0445C13.9205 11.7395 13.3983 11.7395 13.0759 12.0445L10.6428 14.3471L10.6428 1.65403C10.6428 1.22261 10.2734 0.873047 9.81748 0.873047C9.36158 0.873047 8.99219 1.22261 8.99219 1.65403L8.99219 16.2324C8.99219 16.5484 9.19313 16.8332 9.50154 16.9539C9.60363 16.9941 9.71109 17.0134 9.81721 17.0134C10.0321 17.0134 10.2433 16.9341 10.401 16.7846L14.2429 13.1489C14.5653 12.8441 14.5653 12.3494 14.2429 12.0445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighLowPrice);
export default __webpack_public_path__ + "static/media/high-low-price.3ca28c62fa53a1de728ab519f9c7630b.svg";
export { ForwardRef as ReactComponent };